import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { ValidationObserver } from 'vee-validate';
import InputText from 'primevue/inputtext';
import PButton from 'primevue/button';
import BMobileCartItem from '../general/BMobileCartItem.vue';
import IconArrowBack from '~/components/general/icons/IconArrowBack.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BMobileCart',
  props: {
    tickets: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    total: {
      type: String,
      default: '0.00'
    },
    currency: {
      type: String,
      default: ''
    },
    selectionValid: {
      type: Boolean,
      default: false
    },
    discountCodeValue: {
      type: String,
      default: null
    },
    eventInPresale: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'empty', 'submit', 'remove'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var notifier = useNotifier();
    var observer = ref();
    var discountCode = ref(props.discountCodeValue);
    var accessCode = ref(null);
    var numberOfTickets = computed(function () {
      return props.tickets.length;
    });
    function ticketPrice(ticket) {
      var _ticket$donationAmoun;
      return (_ticket$donationAmoun = ticket.donationAmount) !== null && _ticket$donationAmoun !== void 0 ? _ticket$donationAmoun : ticket.finalPrice;
    }
    function closeCart() {
      emit('close');
    }
    function emptyCart() {
      emit('empty');
      showEmptyCartMessage();
    }
    function removeTicket(ticket, index, name) {
      emit('remove', {
        ticket: ticket,
        index: index
      });
      showMessage(name);
    }
    function showMessage(name) {
      notifier.showMessage({
        title: t('mobileCart.removeTicket.title'),
        content: name + ' ' + t('mobileCart.removeTicket.content'),
        type: 'success'
      });
    }
    function showEmptyCartMessage() {
      notifier.showMessage({
        title: t('mobileCart.clearCart.title'),
        content: t('mobileCart.clearCart.content'),
        type: 'success'
      });
    }
    function submit() {
      return _submit.apply(this, arguments);
    }
    function _submit() {
      _submit = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var accessCodeValid;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!props.eventInPresale) {
                _context.next = 2;
                break;
              }
              _context.next = 1;
              return observer.value.validate();
            case 1:
              accessCodeValid = _context.sent;
              if (accessCodeValid) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              emit('submit', discountCode.value, accessCode.value);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _submit.apply(this, arguments);
    }
    return {
      __sfc: true,
      props: props,
      emit: emit,
      t: t,
      notifier: notifier,
      observer: observer,
      discountCode: discountCode,
      accessCode: accessCode,
      numberOfTickets: numberOfTickets,
      ticketPrice: ticketPrice,
      closeCart: closeCart,
      emptyCart: emptyCart,
      removeTicket: removeTicket,
      showMessage: showMessage,
      showEmptyCartMessage: showEmptyCartMessage,
      submit: submit,
      ValidationObserver: ValidationObserver,
      InputText: InputText,
      PButton: PButton,
      BMobileCartItem: BMobileCartItem,
      IconArrowBack: IconArrowBack
    };
  }
});